// wrap in UMD - see https://github.com/umdjs/umd/blob/master/jqueryPlugin.js
(function(factory) {
	if (typeof define === "function" && define.amd) {
        define(["jquery"], function ($) {
          factory($, window, document);
        });
      } else if (typeof module === "object" && module.exports) {
        // In WP/browser bundles, dynamic require("jquery") will blow up.
        // Use global jQuery instead.
        module.exports = factory((typeof jQuery !== "undefined" ? jQuery : undefined), window, document);
      } else {
        factory(jQuery, window, document);
      }
})(function($, window, document, undefined) {
	"use strict";
	var pluginName = "countrySelect", id = 1, // give each instance its own ID for namespaced event handling
	defaults = {
		// Default country
		defaultCountry: "",
		// Position the selected flag inside or outside of the input
		defaultStyling: "inside",
		// don't display these countries
		excludeCountries: [],
		// Display only these countries
		onlyCountries: [],
		// The countries at the top of the list. Defaults to United States and United Kingdoms
		preferredCountries: [ "us", "gb" ],
		// localized country names e.g. { 'de': 'Deutschland' }
		localizedCountries: null,
		// Set the dropdown's width to be the same as the input. This is automatically enabled for small screens.
		responsiveDropdown: ($(window).width() < 768 ? true : false),
	}, keys = {
		UP: 38,
		DOWN: 40,
		ENTER: 13,
		ESC: 27,
		BACKSPACE: 8,
		PLUS: 43,
		SPACE: 32,
		A: 65,
		Z: 90
	}, windowLoaded = false;
	// keep track of if the window.load event has fired as impossible to check after the fact
	$(window).on('load', function() {
		windowLoaded = true;
	});
	function Plugin(element, options) {
		this.element = element;
		this.options = $.extend({}, defaults, options);
		this._defaults = defaults;
		// event namespace
		this.ns = "." + pluginName + id++;
		this._name = pluginName;
		this.init();
	}
	Plugin.prototype = {
		init: function() {
			// Process all the data: onlyCountries, excludeCountries, preferredCountries, defaultCountry etc
			this._processCountryData();
			// Generate the markup
			this._generateMarkup();
			// Set the initial state of the input value and the selected flag
			this._setInitialState();
			// Start all of the event listeners: input keyup, selectedFlag click
			this._initListeners();
			// Return this when the auto country is resolved.
			this.autoCountryDeferred = new $.Deferred();
			// Get auto country.
			this._initAutoCountry();
			// Keep track as the user types
		        this.typedLetters = "";

			return this.autoCountryDeferred;
		},
		/********************
		 *  PRIVATE METHODS
		 ********************/
		// prepare all of the country data, including onlyCountries, excludeCountries, preferredCountries and
		// defaultCountry options
		_processCountryData: function() {
			// set the instances country data objects
			this._setInstanceCountryData();
			// set the preferredCountries property
			this._setPreferredCountries();
			// translate countries according to localizedCountries option
			if (this.options.localizedCountries) this._translateCountriesByLocale();
			// sort countries by name
			if (this.options.onlyCountries.length || this.options.localizedCountries) {
				this.countries.sort(this._countryNameSort);
			}
		},
		// process onlyCountries array if present
		_setInstanceCountryData: function() {
			var that = this;
			if (this.options.onlyCountries.length) {
				var newCountries = [];
				$.each(this.options.onlyCountries, function(i, countryCode) {
					var countryData = that._getCountryData(countryCode, true);
					if (countryData) {
						newCountries.push(countryData);
					}
				});
				this.countries = newCountries;
			} else if (this.options.excludeCountries.length) {
                var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                    return country.toLowerCase();
                });
                this.countries = allCountries.filter(function(country) {
                    return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                });
            } else {
				this.countries = allCountries;
			}
		},
		// Process preferred countries - iterate through the preferences,
		// fetching the country data for each one
		_setPreferredCountries: function() {
			var that = this;
			this.preferredCountries = [];
			$.each(this.options.preferredCountries, function(i, countryCode) {
				var countryData = that._getCountryData(countryCode, false);
				if (countryData) {
					that.preferredCountries.push(countryData);
				}
			});
		},
		// Translate Countries by object literal provided on config
		_translateCountriesByLocale() {
			for (let i = 0; i < this.countries.length; i++) {
				const iso = this.countries[i].iso2.toLowerCase();
				if (this.options.localizedCountries.hasOwnProperty(iso)) {
					this.countries[i].name = this.options.localizedCountries[iso];
				}
			}
		},
		// sort by country name
		_countryNameSort(a, b) {
			return a.name.localeCompare(b.name);
		},
		// generate all of the markup for the plugin: the selected flag overlay, and the dropdown
		_generateMarkup: function() {
			// Country input
			this.countryInput = $(this.element);
			// containers (mostly for positioning)
			var mainClass = "country-select";
			if (this.options.defaultStyling) {
				mainClass += " " + this.options.defaultStyling;
			}
			this.countryInput.wrap($("<div>", {
				"class": mainClass
			}));
			var flagsContainer = $("<div>", {
				"class": "flag-dropdown"
			}).insertAfter(this.countryInput);
			// currently selected flag (displayed to left of input)
			var selectedFlag = $("<div>", {
				"class": "selected-flag"
			}).appendTo(flagsContainer);
			this.selectedFlagInner = $("<div>", {
				"class": "flag"
			}).appendTo(selectedFlag);
			// CSS triangle
			$("<div>", {
				"class": "arrow"
			}).appendTo(selectedFlag);
			// country list contains: preferred countries, then divider, then all countries
			this.countryList = $("<ul>", {
				"class": "country-list v-hide"
			}).appendTo(flagsContainer);
			if (this.preferredCountries.length) {
				this._appendListItems(this.preferredCountries, "preferred");
				$("<li>", {
					"class": "divider"
				}).appendTo(this.countryList);
			}
			//changed 2023-05-02
			this._appendListItems(this.countries.filter(x=>!this.preferredCountries.filter(y=>y.iso2===x.iso2).length), '');
			// Add the hidden input for the country code
			this.countryCodeInput = $("#"+this.countryInput.attr("id")+"_code");
			if (!this.countryCodeInput) {
				this.countryCodeInput = $('<input type="hidden" id="'+this.countryInput.attr("id")+'_code" name="'+this.countryInput.attr("name")+'_code" value="" />');
				this.countryCodeInput.insertAfter(this.countryInput);
			}
			// now we can grab the dropdown height, and hide it properly
			this.dropdownHeight = this.countryList.outerHeight();
			// set the dropdown width according to the input if responsiveDropdown option is present or if it's a small screen
			if (this.options.responsiveDropdown) {
				$(window).resize(function() {
					$('.country-select').each(function() {
						var dropdownWidth = this.offsetWidth;
						$(this).find('.country-list').css("width", dropdownWidth + "px");
					});
				}).resize();
			}
			this.countryList.removeClass("v-hide").addClass("hide");
			// this is useful in lots of places
			this.countryListItems = this.countryList.children(".country");
		},
		// add a country <li> to the countryList <ul> container
		_appendListItems: function(countries, className) {
			// Generate DOM elements as a large temp string, so that there is only
			// one DOM insert event
			var tmp = "";
			// for each country
			$.each(countries, function(i, c) {
				// open the list item
				tmp += '<li class="country ' + className + '" data-country-code="' + c.iso2 + '" data-country-phone="' + c.c + '">';
				// add the flag
				tmp += '<div class="flag ' + c.iso2 + '"></div>';
				// and the country name
				tmp += '<span class="country-name">' + c.name + '</span>';
				// close the list item
				tmp += '</li>';
			});
			this.countryList.append(tmp);
		},
		// set the initial state of the input value and the selected flag
		_setInitialState: function() {
			var flagIsSet = false;
			// If the input is pre-populated, then just update the selected flag
			if (this.countryInput.val()) {
				flagIsSet = this._updateFlagFromInputVal();
			}
			// If the country code input is pre-populated, update the name and the selected flag
			var selectedCode = this.countryCodeInput.val();
			if (selectedCode) {
				this.selectCountry(selectedCode);
			}
			if (!flagIsSet) {
				// flag is not set, so set to the default country
				var defaultCountry;
				// check the defaultCountry option, else fall back to the first in the list
				if (this.options.defaultCountry) {
					defaultCountry = this._getCountryData(this.options.defaultCountry, false);
					// Did we not find the requested default country?
					if (!defaultCountry) {
						defaultCountry = this.preferredCountries.length ? this.preferredCountries[0] : this.countries[0];
					}
				} else {
					defaultCountry = this.preferredCountries.length ? this.preferredCountries[0] : this.countries[0];
				}
				this.defaultCountry = defaultCountry.iso2;
			}
		},
		// initialise the main event listeners: input keyup, and click selected flag
		_initListeners: function() {
			var that = this;
			// Update flag on keyup.
			// Use keyup instead of keypress because we want to update on backspace
			// and instead of keydown because the value hasn't updated when that
			// event is fired.
			// NOTE: better to have this one listener all the time instead of
			// starting it on focus and stopping it on blur, because then you've
			// got two listeners (focus and blur)
			this.countryInput.on("keyup" + this.ns, function() {
				//pjl:this field is readonly on form. so listeners not needed.
				return;
				that._updateFlagFromInputVal();
			});
			// toggle country dropdown on click
			var selectedFlag = this.selectedFlagInner.parent();
			selectedFlag.on("click" + this.ns, function(e) {
				// only intercept this event if we're opening the dropdown
				// else let it bubble up to the top ("click-off-to-close" listener)
				// we cannot just stopPropagation as it may be needed to close another instance
				if (that.countryList.hasClass("hide") && !that.countryInput.prop("disabled")) {
					that._showDropdown();
				}
			});
			// Despite above note, added blur to ensure partially spelled country
			// with correctly chosen flag is spelled out on blur. Also, correctly
			// selects flag when field is autofilled
			this.countryInput.on("blur" + this.ns, function() {
				//pjl:this field is readonly on form. so listeners not needed.
				return;
				if (that.countryInput.val() != that.getSelectedCountryData().name) {
					that.setCountry(that.countryInput.val());
				}
				that.countryInput.val(that.getSelectedCountryData().name);
			});
		},
		_initAutoCountry: function() {
			if (this.options.initialCountry === "auto") {
				this._loadAutoCountry();
			} else {
				if (this.defaultCountry) {
					this.selectCountry(this.defaultCountry);
				}
				this.autoCountryDeferred.resolve();
			}
		},
		// perform the geo ip lookup
		_loadAutoCountry: function() {
			var that = this;

			// 3 options:
			// 1) already loaded (we're done)
			// 2) not already started loading (start)
			// 3) already started loading (do nothing - just wait for loading callback to fire)
			if ($.fn[pluginName].autoCountry) {
				this.handleAutoCountry();
			} else if (!$.fn[pluginName].startedLoadingAutoCountry) {
				// don't do this twice!
				$.fn[pluginName].startedLoadingAutoCountry = true;

				if (typeof this.options.geoIpLookup === 'function') {
					this.options.geoIpLookup(function(countryCode) {
						$.fn[pluginName].autoCountry = countryCode.toLowerCase();
						// tell all instances the auto country is ready
						// TODO: this should just be the current instances
						// UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight away (e.g. if they have already done the geo ip lookup somewhere else). Using setTimeout means that the current thread of execution will finish before executing this, which allows the plugin to finish initialising.
						setTimeout(function() {
							$(".country-select input").countrySelect("handleAutoCountry");
						});
					});
				}
			}
		},
		// Focus input and put the cursor at the end
		_focus: function() {
			this.countryInput.focus();
			var input = this.countryInput[0];
			// works for Chrome, FF, Safari, IE9+
			if (input.setSelectionRange) {
				var len = this.countryInput.val().length;
				input.setSelectionRange(len, len);
			}
		},
		// Show the dropdown
		_showDropdown: function() {
			this._setDropdownPosition();
			// update highlighting and scroll to active list item
			var activeListItem = this.countryList.children(".active");
			this._highlightListItem(activeListItem);
			// show it
			this.countryList.removeClass("hide");
			this._scrollTo(activeListItem);
			// bind all the dropdown-related listeners: mouseover, click, click-off, keydown
			this._bindDropdownListeners();
			// update the arrow
			this.selectedFlagInner.parent().children(".arrow").addClass("up");
		},
		// decide where to position dropdown (depends on position within viewport, and scroll)
		_setDropdownPosition: function() {
			var inputTop = this.countryInput.offset().top, windowTop = $(window).scrollTop(),
			dropdownFitsBelow = inputTop + this.countryInput.outerHeight() + this.dropdownHeight < windowTop + $(window).height(), dropdownFitsAbove = inputTop - this.dropdownHeight > windowTop;
			// dropdownHeight - 1 for border
			var cssTop = !dropdownFitsBelow && dropdownFitsAbove ? "-" + (this.dropdownHeight - 1) + "px" : "";
			this.countryList.css("top", cssTop);
		},
		// we only bind dropdown listeners when the dropdown is open
		_bindDropdownListeners: function() {
			var that = this;
			// when mouse over a list item, just highlight that one
			// we add the class "highlight", so if they hit "enter" we know which one to select
			this.countryList.on("mouseover" + this.ns, ".country", function(e) {
				that._highlightListItem($(this));
			});
			// listen for country selection
			this.countryList.on("click" + this.ns, ".country", function(e) {
				that._selectListItem($(this));
			});
			// click off to close
			// (except when this initial opening click is bubbling up)
			// we cannot just stopPropagation as it may be needed to close another instance
			var isOpening = true;
			$("html").on("click" + this.ns, function(e) {
				e.preventDefault();
				if (!isOpening) {
					that._closeDropdown();
				}
				isOpening = false;
			});
			// Listen for up/down scrolling, enter to select, or letters to jump to country name.
			// Use keydown as keypress doesn't fire for non-char keys and we want to catch if they
			// just hit down and hold it to scroll down (no keyup event).
			// Listen on the document because that's where key events are triggered if no input has focus
			$(document).on("keydown" + this.ns, function(e) {
				// prevent down key from scrolling the whole page,
				// and enter key from submitting a form etc
				e.preventDefault();
				if (e.which == keys.UP || e.which == keys.DOWN) {
					// up and down to navigate
					that._handleUpDownKey(e.which);
				} else if (e.which == keys.ENTER) {
					// enter to select
					that._handleEnterKey();
				} else if (e.which == keys.ESC) {
					// esc to close
					that._closeDropdown();
				} else if (e.which >= keys.A && e.which <= keys.Z || e.which === keys.SPACE) {
					that.typedLetters += String.fromCharCode(e.which);
					that._filterCountries(that.typedLetters);
				} else if (e.which === keys.BACKSPACE) {
					that.typedLetters = that.typedLetters.slice(0, -1);
					that._filterCountries(that.typedLetters);
				}
			});
		},
		// Highlight the next/prev item in the list (and ensure it is visible)
		_handleUpDownKey: function(key) {
			var current = this.countryList.children(".highlight").first();
			var next = key == keys.UP ? current.prev() : current.next();
			if (next.length) {
				// skip the divider
				if (next.hasClass("divider")) {
					next = key == keys.UP ? next.prev() : next.next();
				}
				this._highlightListItem(next);
				this._scrollTo(next);
			}
		},
		// select the currently highlighted item
		_handleEnterKey: function() {
			var currentCountry = this.countryList.children(".highlight").first();
			if (currentCountry.length) {
				this._selectListItem(currentCountry);
			}
		},
		_filterCountries: function(letters) {
			var countries = this.countryListItems.filter(function() {
				return $(this).text().toUpperCase().indexOf(letters) === 0 && !$(this).hasClass("preferred");
			});
			if (countries.length) {
				// if one is already highlighted, then we want the next one
				var highlightedCountry = countries.filter(".highlight").first(), listItem;
				if (highlightedCountry && highlightedCountry.next() && highlightedCountry.next().text().toUpperCase().indexOf(letters) === 0) {
					listItem = highlightedCountry.next();
				} else {
					listItem = countries.first();
				}
				// update highlighting and scroll
				this._highlightListItem(listItem);
				this._scrollTo(listItem);
			}
		},
		// Update the selected flag using the input's current value
		_updateFlagFromInputVal: function() {
			var that = this;
			// try and extract valid country from input
			var value = this.countryInput.val().replace(/(?=[() ])/g, '\\');
			if (value) {
				value = value.replace('+', '\\+');
				var countryCodes = [];
				var matcher = new RegExp(value, "i");
				// Check for ISO codes only
				if(value.length <= 2) {
					for (var i = 0; i < this.countries.length; i++) {
						if (this.countries[i].iso2.match(matcher)) {
							countryCodes.push(this.countries[i].iso2);
						}
					}
				}
				// If no previous matches / larger than 2 chars, then search country name
				if(countryCodes.length == 0) {
					for (var i = 0; i < this.countries.length; i++) {
						if (this.countries[i].name.match(matcher)) {
							countryCodes.push(this.countries[i].iso2);
						}
					}
				}
				// Check if one of the matching countries is already selected
				var alreadySelected = false;
				$.each(countryCodes, function(i, c) {
					if (that.selectedFlagInner.hasClass(c)) {
						alreadySelected = true;
					}
				});
				if (!alreadySelected) {
					this._selectFlag(countryCodes[0]);
					this.countryCodeInput.val(countryCodes[0]).trigger("change");
				}
				// Matching country found
				return true;
			}
			// No match found
			return false;
		},
		// remove highlighting from other list items and highlight the given item
		_highlightListItem: function(listItem) {
			this.countryListItems.removeClass("highlight");
			listItem.addClass("highlight");
		},
		// find the country data for the given country code
		// the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
		_getCountryData: function(countryCode, ignoreOnlyCountriesOption) {
			var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
			for (var i = 0; i < countryList.length; i++) {
				if (countryList[i].iso2 == countryCode) {
					return countryList[i];
				}
			}
			return null;
		},
		// update the selected flag and the active list item
		_selectFlag: function(countryCode) {
			if (! countryCode) {
				return false;
			}
			this.selectedFlagInner.attr("class", "flag " + countryCode);
			// update the title attribute
			var countryData = this._getCountryData(countryCode);
			this.selectedFlagInner.parent().attr("title", countryData.name);
			// update the active list item
			var listItem = this.countryListItems.children(".flag." + countryCode).first().parent();
			this.countryListItems.removeClass("active");
			listItem.addClass("active");
		},
		// called when the user selects a list item from the dropdown
		_selectListItem: function(listItem) {
			// update selected flag and active list item
			var countryCode = listItem.attr("data-country-code");
			this._selectFlag(countryCode);
			this._closeDropdown();
			// update input value
			this._updateName(countryCode);
			this.countryInput.trigger("change");
			this.countryCodeInput.trigger("change");
			// focus the input
			this._focus();
		},
		// close the dropdown and unbind any listeners
		_closeDropdown: function() {
			this.countryList.addClass("hide");
			// update the arrow
			this.selectedFlagInner.parent().children(".arrow").removeClass("up");
			// unbind event listeners
			$(document).off("keydown" + this.ns);
			$("html").off("click" + this.ns);
			// unbind both hover and click listeners
			this.countryList.off(this.ns);
			this.typedLetters = "";
		},
		// check if an element is visible within its container, else scroll until it is
		_scrollTo: function(element) {
			if (!element || !element.offset()) {
				return;
			}
			var container = this.countryList, containerHeight = container.height(), containerTop = container.offset().top, containerBottom = containerTop + containerHeight, elementHeight = element.outerHeight(), elementTop = element.offset().top, elementBottom = elementTop + elementHeight, newScrollTop = elementTop - containerTop + container.scrollTop();
			if (elementTop < containerTop) {
				// scroll up
				container.scrollTop(newScrollTop);
			} else if (elementBottom > containerBottom) {
				// scroll down
				var heightDifference = containerHeight - elementHeight;
				container.scrollTop(newScrollTop - heightDifference);
			}
		},
		// Replace any existing country name with the new one
		_updateName: function(countryCode) {
			this.countryCodeInput.val(countryCode.toUpperCase()).trigger("change");
			this.countryInput.val('+' + this._getCountryData(countryCode).c);
			$('#candidate_country_phone_dial').val(this._getCountryData(countryCode).c)
		},
		/********************
		 *  PUBLIC METHODS
		 ********************/
		// this is called when the geoip call returns
		handleAutoCountry: function() {
			if (this.options.initialCountry === "auto") {
				// we must set this even if there is an initial val in the input: in case the initial val is invalid and they delete it - they should see their auto country
				this.defaultCountry = $.fn[pluginName].autoCountry;
				// if there's no initial value in the input, then update the flag
				if (!this.countryInput.val()) {
					this.selectCountry(this.defaultCountry);
				}
				this.autoCountryDeferred.resolve();
			}
		},
		// get the country data for the currently selected flag
		getSelectedCountryData: function() {
			// rely on the fact that we only set 2 classes on the selected flag element:
			// the first is "flag" and the second is the 2-char country code
			var countryCode = this.selectedFlagInner.attr("class").split(" ")[1];
			return this._getCountryData(countryCode);
		},
		// update the selected flag
		selectCountry: function(countryCode) {
			countryCode = countryCode.toLowerCase();
			// check if already selected
			//changed 2023-05-02
			if (1||!this.selectedFlagInner.hasClass(countryCode)) {
				this._selectFlag(countryCode);
				this._updateName(countryCode);
			}
		},
		// set the input value and update the flag
		setCountry: function(country) {
			this.countryInput.val(country);
			this._updateFlagFromInputVal();
		},
		// remove plugin
		destroy: function() {
			// stop listeners
			this.countryInput.off(this.ns);
			this.selectedFlagInner.parent().off(this.ns);
			// remove markup
			var container = this.countryInput.parent();
			container.before(this.countryInput).remove();
		}
	};
	// adapted to allow public functions
	// using https://github.com/jquery-boilerplate/jquery-boilerplate/wiki/Extending-jQuery-Boilerplate
	$.fn[pluginName] = function(options) {
		var args = arguments;
		// Is the first parameter an object (options), or was omitted,
		// instantiate a new instance of the plugin.
		if (options === undefined || typeof options === "object") {
			return this.each(function() {
				if (!$.data(this, "plugin_" + pluginName)) {
					$.data(this, "plugin_" + pluginName, new Plugin(this, options));
				}
			});
		} else if (typeof options === "string" && options[0] !== "_" && options !== "init") {
			// If the first parameter is a string and it doesn't start
			// with an underscore or "contains" the `init`-function,
			// treat this as a call to a public method.
			// Cache the method call to make it possible to return a value
			var returns;
			this.each(function() {
				var instance = $.data(this, "plugin_" + pluginName);
				// Tests that there's already a plugin-instance
				// and checks that the requested public method exists
				if (instance instanceof Plugin && typeof instance[options] === "function") {
					// Call the method of our plugin instance,
					// and pass it the supplied arguments.
					returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				}
				// Allow instances to be destroyed via the 'destroy' method
				if (options === "destroy") {
					$.data(this, "plugin_" + pluginName, null);
				}
			});
			// If the earlier cached method gives a value back return the value,
			// otherwise return this to preserve chainability.
			return returns !== undefined ? returns : this;
		}
	};
	/********************
   *  STATIC METHODS
   ********************/
	// get the country data object
	$.fn[pluginName].getCountryData = function() {
		return allCountries;
	};
	// set the country data object
	$.fn[pluginName].setCountryData = function(obj) {
		allCountries = obj;
	};
	// Tell JSHint to ignore this warning: "character may get silently deleted by one or more browsers"
	// jshint -W100
	// Array of country objects for the flag dropdown.
	// Each contains a name and country code (ISO 3166-1 alpha-2).
	//
	// Note: using single char property names to keep filesize down
	// n = name
	// i = iso2 (2-char country code)
	var allCountries = $.each(
//changed 2023-05-02		
[
    {
        "n": "United States of America +1",
        "i": "us",
        "c": "1"
    },
    {
        "n": "Brazil +55",
        "i": "br",
        "c": "55"
    },
    {
        "n": "Philippines +63",
        "i": "ph",
        "c": "63"
    },
    {
        "n": "United Kingdom +44",
        "i": "gb",
        "c": "44"
    },
    {
        "n": "Afghanistan +93",
        "i": "af",
        "c": "93"
    },
    {
        "n": "ALA Aland Islands +358",
        "i": "ax",
        "c": "358"
    },
    {
        "n": "Albania +355",
        "i": "al",
        "c": "355"
    },
    {
        "n": "Algeria +213",
        "i": "dz",
        "c": "213"
    },
    {
        "n": "American Samoa +1684",
        "i": "as",
        "c": "1684"
    },
    {
        "n": "Andorra +376",
        "i": "ad",
        "c": "376"
    },
    {
        "n": "Angola +244",
        "i": "ao",
        "c": "244"
    },
    {
        "n": "Anguilla +1264",
        "i": "ai",
        "c": "1264"
    },
    {
        "n": "Antarctica +672",
        "i": "aq",
        "c": "672"
    },
    {
        "n": "Antigua and Barbuda +1268",
        "i": "ag",
        "c": "1268"
    },
    {
        "n": "Argentina +54",
        "i": "ar",
        "c": "54"
    },
    {
        "n": "Armenia +374",
        "i": "am",
        "c": "374"
    },
    {
        "n": "Aruba +297",
        "i": "aw",
        "c": "297"
    },
    {
        "n": "Australia +61",
        "i": "au",
        "c": "61"
    },
    {
        "n": "Austria +43",
        "i": "at",
        "c": "43"
    },
    {
        "n": "Azerbaijan +994",
        "i": "az",
        "c": "994"
    },
    {
        "n": "Bahamas +1242",
        "i": "bs",
        "c": "1242"
    },
    {
        "n": "Bahrain +973",
        "i": "bh",
        "c": "973"
    },
    {
        "n": "Bangladesh +880",
        "i": "bd",
        "c": "880"
    },
    {
        "n": "Barbados +1246",
        "i": "bb",
        "c": "1246"
    },
    {
        "n": "Belarus +375",
        "i": "by",
        "c": "375"
    },
    {
        "n": "Belgium +32",
        "i": "be",
        "c": "32"
    },
    {
        "n": "Belize +501",
        "i": "bz",
        "c": "501"
    },
    {
        "n": "Benin +229",
        "i": "bj",
        "c": "229"
    },
    {
        "n": "Bermuda +1441",
        "i": "bm",
        "c": "1441"
    },
    {
        "n": "Bhutan +975",
        "i": "bt",
        "c": "975"
    },
    {
        "n": "Bolivia +591",
        "i": "bo",
        "c": "591"
    },
    {
        "n": "Bosnia and Herzegovina +387",
        "i": "ba",
        "c": "387"
    },
    {
        "n": "Botswana +267",
        "i": "bw",
        "c": "267"
    },
    {
        "n": "Bouvet Island +47",
        "i": "bv",
        "c": "47"
    },
    {
        "n": "British Virgin Islands +1284",
        "i": "vg",
        "c": "1284"
    },
    {
        "n": "British Indian Ocean Territory +246",
        "i": "io",
        "c": "246"
    },
    {
        "n": "Brunei Darussalam +673",
        "i": "bn",
        "c": "673"
    },
    {
        "n": "Bulgaria +359",
        "i": "bg",
        "c": "359"
    },
    {
        "n": "Burkina Faso +226",
        "i": "bf",
        "c": "226"
    },
    {
        "n": "Burundi +257",
        "i": "bi",
        "c": "257"
    },
    {
        "n": "Cambodia +855",
        "i": "kh",
        "c": "855"
    },
    {
        "n": "Cameroon +237",
        "i": "cm",
        "c": "237"
    },
    {
        "n": "Canada +1",
        "i": "ca",
        "c": "1"
    },
    {
        "n": "Cape Verde +238",
        "i": "cv",
        "c": "238"
    },
    {
        "n": "Cayman Islands + 345",
        "i": "ky",
        "c": " 345"
    },
    {
        "n": "Central African Republic +236",
        "i": "cf",
        "c": "236"
    },
    {
        "n": "Chad +235",
        "i": "td",
        "c": "235"
    },
    {
        "n": "Chile +56",
        "i": "cl",
        "c": "56"
    },
    {
        "n": "China +86",
        "i": "cn",
        "c": "86"
    },
    {
        "n": "Hong Kong, SAR China +852",
        "i": "hk",
        "c": "852"
    },
    {
        "n": "Macao, SAR China +853",
        "i": "mo",
        "c": "853"
    },
    {
        "n": "Christmas Island +61",
        "i": "cx",
        "c": "61"
    },
    {
        "n": "Cocos (Keeling) Islands +61",
        "i": "cc",
        "c": "61"
    },
    {
        "n": "Colombia +57",
        "i": "co",
        "c": "57"
    },
    {
        "n": "Comoros +269",
        "i": "km",
        "c": "269"
    },
    {
        "n": "Congo (Brazzaville) +242",
        "i": "cg",
        "c": "242"
    },
    {
        "n": "Congo, (Kinshasa) +243",
        "i": "cd",
        "c": "243"
    },
    {
        "n": "Cook Islands +682",
        "i": "ck",
        "c": "682"
    },
    {
        "n": "Costa Rica +506",
        "i": "cr",
        "c": "506"
    },
    {
        "n": "Côte d’Ivoire +225",
        "i": "ci",
        "c": "225"
    },
    {
        "n": "Croatia +385",
        "i": "hr",
        "c": "385"
    },
    {
        "n": "Cuba +53",
        "i": "cu",
        "c": "53"
    },
    {
        "n": "Cyprus +357",
        "i": "cy",
        "c": "357"
    },
    {
        "n": "Czech Republic +420",
        "i": "cz",
        "c": "420"
    },
    {
        "n": "Denmark +45",
        "i": "dk",
        "c": "45"
    },
    {
        "n": "Djibouti +253",
        "i": "dj",
        "c": "253"
    },
    {
        "n": "Dominica +1767",
        "i": "dm",
        "c": "1767"
    },
    {
        "n": "Dominican Republic +1849",
        "i": "do",
        "c": "1849"
    },
    {
        "n": "Ecuador +593",
        "i": "ec",
        "c": "593"
    },
    {
        "n": "Egypt +20",
        "i": "eg",
        "c": "20"
    },
    {
        "n": "El Salvador +503",
        "i": "sv",
        "c": "503"
    },
    {
        "n": "Equatorial Guinea +240",
        "i": "gq",
        "c": "240"
    },
    {
        "n": "Eritrea +291",
        "i": "er",
        "c": "291"
    },
    {
        "n": "Estonia +372",
        "i": "ee",
        "c": "372"
    },
    {
        "n": "Ethiopia +251",
        "i": "et",
        "c": "251"
    },
    {
        "n": "Falkland Islands (Malvinas) +500",
        "i": "fk",
        "c": "500"
    },
    {
        "n": "Faroe Islands +298",
        "i": "fo",
        "c": "298"
    },
    {
        "n": "Fiji +679",
        "i": "fj",
        "c": "679"
    },
    {
        "n": "Finland +358",
        "i": "fi",
        "c": "358"
    },
    {
        "n": "France +33",
        "i": "fr",
        "c": "33"
    },
    {
        "n": "French Guiana +594",
        "i": "gf",
        "c": "594"
    },
    {
        "n": "French Polynesia +689",
        "i": "pf",
        "c": "689"
    },
    {
        "n": "French Southern Territories +262",
        "i": "tf",
        "c": "262"
    },
    {
        "n": "Gabon +241",
        "i": "ga",
        "c": "241"
    },
    {
        "n": "Gambia +220",
        "i": "gm",
        "c": "220"
    },
    {
        "n": "Georgia +995",
        "i": "ge",
        "c": "995"
    },
    {
        "n": "Germany +49",
        "i": "de",
        "c": "49"
    },
    {
        "n": "Ghana +233",
        "i": "gh",
        "c": "233"
    },
    {
        "n": "Gibraltar +350",
        "i": "gi",
        "c": "350"
    },
    {
        "n": "Greece +30",
        "i": "gr",
        "c": "30"
    },
    {
        "n": "Greenland +299",
        "i": "gl",
        "c": "299"
    },
    {
        "n": "Grenada +1473",
        "i": "gd",
        "c": "1473"
    },
    {
        "n": "Guadeloupe +590",
        "i": "gp",
        "c": "590"
    },
    {
        "n": "Guam +1671",
        "i": "gu",
        "c": "1671"
    },
    {
        "n": "Guatemala +502",
        "i": "gt",
        "c": "502"
    },
    {
        "n": "Guernsey +44",
        "i": "gg",
        "c": "44"
    },
    {
        "n": "Guinea +224",
        "i": "gn",
        "c": "224"
    },
    {
        "n": "Guinea-Bissau +245",
        "i": "gw",
        "c": "245"
    },
    {
        "n": "Guyana +595",
        "i": "gy",
        "c": "595"
    },
    {
        "n": "Haiti +509",
        "i": "ht",
        "c": "509"
    },
    {
        "n": "Heard and Mcdonald Islands +61",
        "i": "hm",
        "c": "61"
    },
    {
        "n": "Holy See (Vatican City State) +379",
        "i": "va",
        "c": "379"
    },
    {
        "n": "Honduras +504",
        "i": "hn",
        "c": "504"
    },
    {
        "n": "Hungary +36",
        "i": "hu",
        "c": "36"
    },
    {
        "n": "Iceland +354",
        "i": "is",
        "c": "354"
    },
    {
        "n": "India +91",
        "i": "in",
        "c": "91"
    },
    {
        "n": "Indonesia +62",
        "i": "id",
        "c": "62"
    },
    {
        "n": "Iran, Islamic Republic of +98",
        "i": "ir",
        "c": "98"
    },
    {
        "n": "Iraq +964",
        "i": "iq",
        "c": "964"
    },
    {
        "n": "Ireland +353",
        "i": "ie",
        "c": "353"
    },
    {
        "n": "Isle of Man +44",
        "i": "im",
        "c": "44"
    },
    {
        "n": "Israel +972",
        "i": "il",
        "c": "972"
    },
    {
        "n": "Italy +39",
        "i": "it",
        "c": "39"
    },
    {
        "n": "Jamaica +1876",
        "i": "jm",
        "c": "1876"
    },
    {
        "n": "Japan +81",
        "i": "jp",
        "c": "81"
    },
    {
        "n": "Jersey +44",
        "i": "je",
        "c": "44"
    },
    {
        "n": "Jordan +962",
        "i": "jo",
        "c": "962"
    },
    {
        "n": "Kazakhstan +77",
        "i": "kz",
        "c": "77"
    },
    {
        "n": "Kenya +254",
        "i": "ke",
        "c": "254"
    },
    {
        "n": "Kiribati +686",
        "i": "ki",
        "c": "686"
    },
    {
        "n": "Korea (North) +850",
        "i": "kp",
        "c": "850"
    },
    {
        "n": "Korea (South) +82",
        "i": "kr",
        "c": "82"
    },
    {
        "n": "Kuwait +965",
        "i": "kw",
        "c": "965"
    },
    {
        "n": "Kyrgyzstan +996",
        "i": "kg",
        "c": "996"
    },
    {
        "n": "Lao PDR +856",
        "i": "la",
        "c": "856"
    },
    {
        "n": "Latvia +371",
        "i": "lv",
        "c": "371"
    },
    {
        "n": "Lebanon +961",
        "i": "lb",
        "c": "961"
    },
    {
        "n": "Lesotho +266",
        "i": "ls",
        "c": "266"
    },
    {
        "n": "Liberia +231",
        "i": "lr",
        "c": "231"
    },
    {
        "n": "Libya +218",
        "i": "ly",
        "c": "218"
    },
    {
        "n": "Liechtenstein +423",
        "i": "li",
        "c": "423"
    },
    {
        "n": "Lithuania +370",
        "i": "lt",
        "c": "370"
    },
    {
        "n": "Luxembourg +352",
        "i": "lu",
        "c": "352"
    },
    {
        "n": "Macedonia, Republic of +389",
        "i": "mk",
        "c": "389"
    },
    {
        "n": "Madagascar +261",
        "i": "mg",
        "c": "261"
    },
    {
        "n": "Malawi +265",
        "i": "mw",
        "c": "265"
    },
    {
        "n": "Malaysia +60",
        "i": "my",
        "c": "60"
    },
    {
        "n": "Maldives +960",
        "i": "mv",
        "c": "960"
    },
    {
        "n": "Mali +223",
        "i": "ml",
        "c": "223"
    },
    {
        "n": "Malta +356",
        "i": "mt",
        "c": "356"
    },
    {
        "n": "Marshall Islands +692",
        "i": "mh",
        "c": "692"
    },
    {
        "n": "Martinique +596",
        "i": "mq",
        "c": "596"
    },
    {
        "n": "Mauritania +222",
        "i": "mr",
        "c": "222"
    },
    {
        "n": "Mauritius +230",
        "i": "mu",
        "c": "230"
    },
    {
        "n": "Mayotte +262",
        "i": "yt",
        "c": "262"
    },
    {
        "n": "Mexico +52",
        "i": "mx",
        "c": "52"
    },
    {
        "n": "Micronesia, Federated States of +691",
        "i": "fm",
        "c": "691"
    },
    {
        "n": "Moldova +373",
        "i": "md",
        "c": "373"
    },
    {
        "n": "Monaco +377",
        "i": "mc",
        "c": "377"
    },
    {
        "n": "Mongolia +976",
        "i": "mn",
        "c": "976"
    },
    {
        "n": "Montenegro +382",
        "i": "me",
        "c": "382"
    },
    {
        "n": "Montserrat +1664",
        "i": "ms",
        "c": "1664"
    },
    {
        "n": "Morocco +212",
        "i": "ma",
        "c": "212"
    },
    {
        "n": "Mozambique +258",
        "i": "mz",
        "c": "258"
    },
    {
        "n": "Myanmar +95",
        "i": "mm",
        "c": "95"
    },
    {
        "n": "Namibia +264",
        "i": "na",
        "c": "264"
    },
    {
        "n": "Nauru +674",
        "i": "nr",
        "c": "674"
    },
    {
        "n": "Nepal +977",
        "i": "np",
        "c": "977"
    },
    {
        "n": "Netherlands +31",
        "i": "nl",
        "c": "31"
    },
    {
        "n": "Netherlands Antilles +599",
        "i": "an",
        "c": "599"
    },
    {
        "n": "New Caledonia +687",
        "i": "nc",
        "c": "687"
    },
    {
        "n": "New Zealand +64",
        "i": "nz",
        "c": "64"
    },
    {
        "n": "Nicaragua +505",
        "i": "ni",
        "c": "505"
    },
    {
        "n": "Niger +227",
        "i": "ne",
        "c": "227"
    },
    {
        "n": "Nigeria +234",
        "i": "ng",
        "c": "234"
    },
    {
        "n": "Niue +683",
        "i": "nu",
        "c": "683"
    },
    {
        "n": "Norfolk Island +672",
        "i": "nf",
        "c": "672"
    },
    {
        "n": "Northern Mariana Islands +1670",
        "i": "mp",
        "c": "1670"
    },
    {
        "n": "Norway +47",
        "i": "no",
        "c": "47"
    },
    {
        "n": "Oman +968",
        "i": "om",
        "c": "968"
    },
    {
        "n": "Pakistan +92",
        "i": "pk",
        "c": "92"
    },
    {
        "n": "Palau +680",
        "i": "pw",
        "c": "680"
    },
    {
        "n": "Palestinian Territory +970",
        "i": "ps",
        "c": "970"
    },
    {
        "n": "Panama +507",
        "i": "pa",
        "c": "507"
    },
    {
        "n": "Papua New Guinea +675",
        "i": "pg",
        "c": "675"
    },
    {
        "n": "Paraguay +595",
        "i": "py",
        "c": "595"
    },
    {
        "n": "Peru +51",
        "i": "pe",
        "c": "51"
    },
    {
        "n": "Pitcairn +872",
        "i": "pn",
        "c": "872"
    },
    {
        "n": "Poland +48",
        "i": "pl",
        "c": "48"
    },
    {
        "n": "Portugal +351",
        "i": "pt",
        "c": "351"
    },
    {
        "n": "Puerto Rico +1939",
        "i": "pr",
        "c": "1939"
    },
    {
        "n": "Qatar +974",
        "i": "qa",
        "c": "974"
    },
    {
        "n": "Réunion +262",
        "i": "re",
        "c": "262"
    },
    {
        "n": "Romania +40",
        "i": "ro",
        "c": "40"
    },
    {
        "n": "Russian Federation +7",
        "i": "ru",
        "c": "7"
    },
    {
        "n": "Rwanda +250",
        "i": "rw",
        "c": "250"
    },
    {
        "n": "Saint-Barthélemy +590",
        "i": "bl",
        "c": "590"
    },
    {
        "n": "Saint Helena +290",
        "i": "sh",
        "c": "290"
    },
    {
        "n": "Saint Kitts and Nevis +1869",
        "i": "kn",
        "c": "1869"
    },
    {
        "n": "Saint Lucia +1758",
        "i": "lc",
        "c": "1758"
    },
    {
        "n": "Saint-Martin (French part) +590",
        "i": "mf",
        "c": "590"
    },
    {
        "n": "Saint Pierre and Miquelon +508",
        "i": "pm",
        "c": "508"
    },
    {
        "n": "Saint Vincent and Grenadines +1784",
        "i": "vc",
        "c": "1784"
    },
    {
        "n": "Samoa +685",
        "i": "ws",
        "c": "685"
    },
    {
        "n": "San Marino +378",
        "i": "sm",
        "c": "378"
    },
    {
        "n": "Sao Tome and Principe +239",
        "i": "st",
        "c": "239"
    },
    {
        "n": "Saudi Arabia +966",
        "i": "sa",
        "c": "966"
    },
    {
        "n": "Senegal +221",
        "i": "sn",
        "c": "221"
    },
    {
        "n": "Serbia +381",
        "i": "rs",
        "c": "381"
    },
    {
        "n": "Seychelles +248",
        "i": "sc",
        "c": "248"
    },
    {
        "n": "Sierra Leone +232",
        "i": "sl",
        "c": "232"
    },
    {
        "n": "Singapore +65",
        "i": "sg",
        "c": "65"
    },
    {
        "n": "Slovakia +421",
        "i": "sk",
        "c": "421"
    },
    {
        "n": "Slovenia +386",
        "i": "si",
        "c": "386"
    },
    {
        "n": "Solomon Islands +677",
        "i": "sb",
        "c": "677"
    },
    {
        "n": "Somalia +252",
        "i": "so",
        "c": "252"
    },
    {
        "n": "South Africa +27",
        "i": "za",
        "c": "27"
    },
    {
        "n": "South Georgia and the South Sandwich Islands +500",
        "i": "gs",
        "c": "500"
    },
    {
        "n": "South Sudan +211",
        "i": "ss",
        "c": "211"
    },
    {
        "n": "Spain +34",
        "i": "es",
        "c": "34"
    },
    {
        "n": "Sri Lanka +94",
        "i": "lk",
        "c": "94"
    },
    {
        "n": "Sudan +249",
        "i": "sd",
        "c": "249"
    },
    {
        "n": "Suriname +597",
        "i": "sr",
        "c": "597"
    },
    {
        "n": "Svalbard and Jan Mayen Islands +47",
        "i": "sj",
        "c": "47"
    },
    {
        "n": "Swaziland +268",
        "i": "sz",
        "c": "268"
    },
    {
        "n": "Sweden +46",
        "i": "se",
        "c": "46"
    },
    {
        "n": "Switzerland +41",
        "i": "ch",
        "c": "41"
    },
    {
        "n": "Syrian Arab Republic (Syria) +963",
        "i": "sy",
        "c": "963"
    },
    {
        "n": "Taiwan, Republic of China +886",
        "i": "tw",
        "c": "886"
    },
    {
        "n": "Tajikistan +992",
        "i": "tj",
        "c": "992"
    },
    {
        "n": "Tanzania, United Republic of +255",
        "i": "tz",
        "c": "255"
    },
    {
        "n": "Thailand +66",
        "i": "th",
        "c": "66"
    },
    {
        "n": "Timor-Leste +670",
        "i": "tl",
        "c": "670"
    },
    {
        "n": "Togo +228",
        "i": "tg",
        "c": "228"
    },
    {
        "n": "Tokelau +690",
        "i": "tk",
        "c": "690"
    },
    {
        "n": "Tonga +676",
        "i": "to",
        "c": "676"
    },
    {
        "n": "Trinidad and Tobago +1868",
        "i": "tt",
        "c": "1868"
    },
    {
        "n": "Tunisia +216",
        "i": "tn",
        "c": "216"
    },
    {
        "n": "Turkey +90",
        "i": "tr",
        "c": "90"
    },
    {
        "n": "Turkmenistan +993",
        "i": "tm",
        "c": "993"
    },
    {
        "n": "Turks and Caicos Islands +1649",
        "i": "tc",
        "c": "1649"
    },
    {
        "n": "Tuvalu +688",
        "i": "tv",
        "c": "688"
    },
    {
        "n": "Uganda +256",
        "i": "ug",
        "c": "256"
    },
    {
        "n": "Ukraine +380",
        "i": "ua",
        "c": "380"
    },
    {
        "n": "United Arab Emirates +971",
        "i": "ae",
        "c": "971"
    },
    {
        "n": "US Minor Outlying Islands +1",
        "i": "um",
        "c": "1"
    },
    {
        "n": "Uruguay +598",
        "i": "uy",
        "c": "598"
    },
    {
        "n": "Uzbekistan +998",
        "i": "uz",
        "c": "998"
    },
    {
        "n": "Vanuatu +678",
        "i": "vu",
        "c": "678"
    },
    {
        "n": "Venezuela (Bolivarian Republic) +58",
        "i": "ve",
        "c": "58"
    },
    {
        "n": "Viet Nam +84",
        "i": "vn",
        "c": "84"
    },
    {
        "n": "Virgin Islands, US +1340",
        "i": "vi",
        "c": "1340"
    },
    {
        "n": "Wallis and Futuna Islands +681",
        "i": "wf",
        "c": "681"
    },
    {
        "n": "Western Sahara +212",
        "i": "eh",
        "c": "212",
    },
    {
        "n": "Yemen +967",
        "i": "ye",
        "c": "967"
    },
    {
        "n": "Zambia +260",
        "i": "zm",
        "c": "260"
    },
    {
        "n": "Zimbabwe +263",
        "i": "zw",
        "c": "263"
    }
], function(i, c) {
		c.name = c.n;
		c.iso2 = c.i;
		delete c.n;
		delete c.i;
	});
});
